const TIME_RANGES = ["24H", "7D", "1M", "3M", "YTD", "1Y", "MAX"];
const TimeRangeSelector = ({ active, onChange }) => (
  <div className="inline-flex items-center rounded-[8px] bg-background-secondary p-1">
    {TIME_RANGES.map((range) => {
      const isActive = active === range;

      return (
        <button
          key={range}
          type="button"
          onClick={() => onChange(range)}
          className={`rounded-[6px] px-[10px] py-[8px] text-xs font-medium leading-none custom-transition ${
            isActive
              ? "bg-background-surface text-text-primary shadow-[0_1px_2px_rgba(0,0,0,0.06)]"
              : "bg-transparent text-text-secondary hover:text-text-primary"
          }`}
        >
          {range}
        </button>
      );
    })}
  </div>
);

export default TimeRangeSelector;
